import script from "./TimesTables.vue?vue&type=script&setup=true&lang=js"
export * from "./TimesTables.vue?vue&type=script&setup=true&lang=js"

import "./TimesTables.vue?vue&type=style&index=0&id=3ef2c0b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef2c0b4"]])

export default __exports__